import { render, staticRenderFns } from "./Panda.vue?vue&type=template&id=b27a3b86&"
import script from "./Panda.vue?vue&type=script&lang=js&"
export * from "./Panda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports